import type { RoomCalendarBooking } from '../types';
import {
  availableIntervals,
  OFFICE_END_MINUTES,
  OFFICE_START_MINUTES,
  roomCalendarBookingSegments,
  timeFromMinutes,
  timelineStyle,
} from '../lib/roomCalendar';
import { formatTimeRange } from '../lib/utils';

export default function RoomDayTimeline({
  bookings,
  date,
  compact = false,
  onBookingClick,
  onFreeClick,
  label,
}: {
  bookings: RoomCalendarBooking[];
  date: string;
  compact?: boolean;
  onBookingClick?: (booking: RoomCalendarBooking) => void;
  onFreeClick?: (startMinutes: number) => void;
  label: string;
}) {
  const segments = roomCalendarBookingSegments(bookings, date).filter((segment) => (
    segment.start < OFFICE_END_MINUTES
    && segment.end > OFFICE_START_MINUTES
  ));
  const free = availableIntervals(bookings, date);

  return <div className={`room-day-timeline${compact ? ' compact' : ''}`} role={compact && !onBookingClick ? 'img' : 'group'} aria-label={label}>
    {onFreeClick ? free.map((interval) => <button
      type="button"
      className="room-free-slot"
      style={timelineStyle(interval.start, interval.end)}
      key={`${interval.start}-${interval.end}`}
      onClick={() => onFreeClick(interval.start)}
      aria-label={`Cipta mesyuarat pada waktu lapang ${formatTimeRange(
        timeFromMinutes(interval.start),
        timeFromMinutes(interval.end),
      )}`}
    />) : null}
    {segments.map((segment) => {
      const { booking, start, end } = segment;
      const displayTime = formatTimeRange(timeFromMinutes(start), timeFromMinutes(end));
      const content = compact ? null : <><strong>{booking.title}</strong><span>{displayTime}</span></>;
      const commonProps = {
        className: `room-booking-block${segment.kind === 'RELEASED_HISTORY' ? ' room-booking-history' : ''}`,
        style: timelineStyle(start, end),
        title: `${booking.title} · ${displayTime}`,
      };
      const key = `${booking.reservation_id}-${segment.kind}-${start}-${end}`;
      return onBookingClick
        ? <button type="button" {...commonProps} key={key} onClick={() => onBookingClick(booking)} aria-label={`Lihat ${commonProps.title}`}>{content}</button>
        : <span {...commonProps} key={key} aria-hidden="true">{content}</span>;
    })}
  </div>;
}
